// extracted by mini-css-extract-plugin
export default {"headContainer":"HeadLegend_headContainer__b-ajX","head":"HeadLegend_head__a7P0K","description":"HeadLegend_description__j-lTD"};